'use es6';

import Actions from 'AdsUI/lib/Actions';
import { Map as ImmutableMap, List } from 'immutable';
import { DisallowedErrorContentReasons } from 'AdsUI/records/ad-management/AdCreationCreativeRecord';
import Raven from 'raven-js';

const AdWordsAdCreationErrorReducer = (state = ImmutableMap(), action) => {
  const {
    type
  } = action;

  switch (type) {
    case Actions.LEAD_AD_CREATION_STATE_SET:
    case Actions.LEAD_AD_CREATION_RESET:
    case Actions.LEAD_AD_CREATE_START:
      {
        return ImmutableMap();
      }

    case Actions.LEAD_AD_CREATE_FAILED:
      {
        const {
          meta: {
            responseJSON = {}
          } = {}
        } = action;

        if (responseJSON.errorType !== 'DISALLOWED_CONTENT') {
          return state;
        }

        const {
          disallowedContentList = []
        } = responseJSON;
        return disallowedContentList.reduce((errorMap, {
          reason,
          content
        }) => {
          if (!Object.values(DisallowedErrorContentReasons).includes(reason)) {
            Raven.captureMessage('Missing disallowed content error reason', {
              extra: {
                reason,
                content
              }
            });
            reason = DisallowedErrorContentReasons.UNKNOWN;
          }

          if (errorMap.has(reason)) {
            return errorMap.updateIn([reason], contents => contents.push(content));
          }

          return errorMap.set(reason, List([content]));
        }, ImmutableMap());
      }

    default:
      {
        return state;
      }
  }
};

export default AdWordsAdCreationErrorReducer;